/* ============================================================
   Superfly — My Account header icon auto-injector
   ------------------------------------------------------------
   Injects a customer/account icon next to the existing cart icon
   in the site header. Matches the cart icon's markup, classes,
   spacing and stroke style exactly.

   Activation: this file is loaded by `snippet 'myacct-header-icon'`
   which is automatically included by sections/my-account-hub.liquid
   AND can be rendered globally by adding ONE line to theme.liquid
   (see README). The script is idempotent — safe to load multiple times.
   ============================================================ */
(function () {
  if (window.__superflyAccountIconMounted) return;
  window.__superflyAccountIconMounted = true;

  var ACCOUNT_URL = '/account';                    // Shopify native — will redirect to login if logged out
  var ICON_HTML =
    '<a href="' + ACCOUNT_URL + '" data-account-link class="tick" data-testid="header-account-icon" aria-label="My account" style="display:flex;align-items:center;gap:8px">' +
      '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>' +
        '<circle cx="12" cy="7" r="4"/>' +
      '</svg>' +
      '<span class="nav-cart-label">Account</span>' +
    '</a>';

  function mount() {
    // Avoid double-mount
    if (document.querySelector('[data-account-link]')) return true;

    // Find the cart trigger
    var cart = document.querySelector('[data-cart-open]');
    if (!cart) return false;

    // Build a wrapper so we don't fight with the cart's flex sibling
    var wrap = document.createElement('span');
    wrap.style.display = 'inline-flex';
    wrap.innerHTML = ICON_HTML;
    var iconEl = wrap.firstChild;

    // Insert immediately BEFORE the cart icon (matches boat-style: account → cart)
    cart.parentNode.insertBefore(iconEl, cart);

    // Re-point to our custom dashboard page if it exists
    fetch('/pages/my-account', { method: 'HEAD', cache: 'force-cache' })
      .then(function (res) {
        if (res.ok) {
          iconEl.setAttribute('href', '/pages/my-account');
        }
      })
      .catch(function () { /* silently keep /account fallback */ });

    return true;
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    if (mount()) return;
    // Header may render late — observe DOM for up to 4s
    var attempts = 0;
    var iv = setInterval(function () {
      attempts++;
      if (mount() || attempts > 20) clearInterval(iv);
    }, 200);
  });
})();
